import { UseStore } from '@eastcoal/common/types/zustand'
import { useShallowStore } from '@eastcoal/common/utils/zustand'

import { SystemTimeStore } from './interface'
import { systemTimeStore } from './store'

export const useSystemTime: UseStore<SystemTimeStore> = selector => {
  return useShallowStore(systemTimeStore, selector)
}
